import React, { useState } from 'react'
import {ChevronDown} from 'lucide-react'

function Faq() {
  const [open, setOpen] = useState<number | null>(0)

  const faqs = [
    {
      q: 'As receitas são indicadas para quem deseja reduzir o consumo de açúcar refinado?',
      a: 'As receitas utilizam ingredientes sem açúcar refinado e podem ser uma excelente alternativa para quem deseja reduzir esse ingrediente na alimentação. Caso você possua diabetes ou qualquer outra condição específica de saúde, recomendamos seguir sempre as orientações do seu médico ou nutricionista.',
    },
    {
      q: 'Preciso de ingredientes difíceis de encontrar?',
      a: 'Não. Todas as receitas usam ingredientes acessíveis, encontrados em supermercados comuns.',
    },
    {
      q: 'Como recebo o acesso após a compra?',
      a: 'O acesso é liberado imediatamente por e-mail, com login para o aplicativo e conteúdo completo.',
    },
    {
      q: 'Funciona em qualquer celular?',
      a: 'Sim. O aplicativo funciona em iOS, Android, tablets e computadores, sem necessidade de instalação.',
    },
    {
      q: 'E se eu não gostar?',
      a: 'Você tem 7 dias de garantia incondicional. Basta pedir e devolvemos seu dinheiro, sem perguntas.',
    },
  ]

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-[800px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14 animate-fade-up">
          <p className="text-[#D9891B] font-semibold uppercase tracking-wide text-sm mb-3">Perguntas frequentes</p>
          <h2 className="font-display text-[#49352B] text-3xl md:text-5xl font-bold">
            Ainda tem dúvidas?
          </h2>
        </div>

        <div className="space-y-5">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-[#FCFAF5] rounded-[20px] border border-[#EBD9C3] overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300 animate-fade-up"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full px-7 py-6 flex items-center justify-between text-left"
              >
                <span className="font-display font-semibold text-[#49352B] text-lg">{item.q}</span>
                <ChevronDown
                  className={`w-5 h-5 text-[#D9891B] flex-shrink-0 transition-transform duration-300 ${open === i ? 'rotate-180' : ''}`}
                />
              </button>
              <div
                className="px-7 grid transition-all duration-300 ease-in-out"
                style={{ gridTemplateRows: open === i ? '1fr' : '0fr', opacity: open === i ? 1 : 0, paddingBottom: open === i ? '1.5rem' : 0 }}
              >
                <div className="overflow-hidden">
                  <p className="text-[#49352B]/70 leading-relaxed">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Faq
